import { E as EmblaCarousel } from './embla-carousel.esm-CCUHK2kO.js';

class StoryTelling extends HTMLElement {
  connectedCallback() {
    const dotsViewport = this.querySelector('.embla-dots__viewport');
    const slides = this.querySelectorAll('.embla__slide');
    const dots = this.querySelectorAll('.embla_dot');

    const dotsEmbla = EmblaCarousel(dotsViewport, {
      dragFree: true,
      dragThreshold: 10,
      slidesToScroll: 1,
      containScroll: 'keepSnaps',
      direction: document.dir || 'ltr',
    });

    let selected = 0;
    let animating = false;

    const getStagger = () => (window.matchMedia('(min-width: 1024px)').matches ? 16 : 8);

    function updateSlides() {
      const stagger = getStagger();
      slides.forEach((slide, i) => {
        slide.style.top = `${i * stagger}px`;
        slide.style.zIndex = slides.length - Math.abs(i - selected);
      });

      dots.forEach((dot, i) => {
        const isActive = i === selected;
        const p = dot.querySelector('p');
        p.classList.toggle('text-conversion-500', isActive);
        p.classList.toggle('text-blue', !isActive);
        const span = dot.querySelector('button span');
        span.classList.toggle('bg-conversion-500', isActive);
        span.classList.toggle('bg-white', !isActive);
      });

      dotsEmbla.goTo(selected);
    }

    function animateOneStep(goingForward) {
      const toIndex = selected + (goingForward ? 1 : -1);
      const outgoing = slides[selected];
      const incoming = slides[toIndex];

      if (goingForward) {
        incoming.animate(
          [
            { transform: 'translateY(100%)', opacity: 1 },
            { transform: 'translateY(0)', opacity: 1 },
          ],
          { duration: 400, easing: 'ease', fill: 'forwards' }
        );
      } else {
        const anim = outgoing.animate(
          [
            { transform: 'translateY(0)', opacity: 1 },
            { transform: 'translateY(40px)', opacity: 0 },
          ],
          { duration: 400, easing: 'ease', fill: 'forwards' }
        );
        anim.onfinish = () => {
          outgoing.style.zIndex = '';
        };
        outgoing.style.zIndex = slides.length + 1;
      }

      selected = toIndex;
      updateSlides();
    }

    function goToSlide(targetIndex) {
      if (targetIndex === selected) return;
      if (animating) return;

      animating = true;
      const goingForward = targetIndex > selected;
      animateOneStep(goingForward);

      setTimeout(() => {
        animating = false;
        if (selected !== targetIndex) goToSlide(targetIndex);
      }, 450);
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => goToSlide(index));
    });

    const wrapper = this.closest('[data-story-wrapper]');
    let wrapperTop = 0;

    const calcWrapperTop = () => {
      wrapperTop = wrapper.getBoundingClientRect().top + window.scrollY;
    };

    const onScroll = () => {
      const scrollRoom = wrapper.offsetHeight - window.innerHeight;
      if (scrollRoom <= 0) return;

      const scrolled = window.scrollY - wrapperTop;
      const progress = Math.max(0, Math.min(scrolled / scrollRoom, 1));
      const targetIndex = Math.round(progress * (slides.length - 1));

      goToSlide(targetIndex);
    };

    const isDesktop = () => window.matchMedia('(min-width: 1024px)').matches;

    const isInView = () => {
      const rect = this.getBoundingClientRect();
      return (
        (rect.top <= 0 && rect.bottom >= window.innerHeight) ||
        (rect.top >= 0 && rect.bottom <= window.innerHeight)
      );
    };

    const onWheel = (e) => {
      if (!isDesktop()) return;
      if (!isInView()) return;

      const forward = e.deltaY > 0;
      if (forward && selected >= slides.length - 1) return;
      if (!forward && selected <= 0) return;

      e.preventDefault();
      goToSlide(selected + (forward ? 1 : -1));
    };

    const onResize = () => {
      calcWrapperTop();
      updateSlides();
    };

    calcWrapperTop();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('resize', onResize);

    this.cleanup = () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('wheel', onWheel);
      window.removeEventListener('resize', onResize);
    };

    updateSlides();
  }

  disconnectedCallback() {
    this.cleanup?.();
  }
}

customElements.define('story-telling', StoryTelling);
